import { StockMgmtTable } from 'src/domain/enums/stock-management-table';
import { useTable } from './useTable';

export const useStockManagementTableKey = () => {
    const selectedTable = useTable();

    return selectedTable === StockMgmtTable.Categories ? 'categories-table' : 'totals-table';
};
